import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SocialLink } from 'app/modules/social/models/social-link.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class SocialService implements Resolve<SocialLink[] | Observable<SocialLink[]>> {
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): SocialLink[] | Observable<SocialLink[]> {
    const projectId = +route.params['id'];
    return this.byProject(projectId);
  }

  constructor(private http: HttpClient) {}

  byProject(id: number): Observable<SocialLink[]> {
    return this.http.get<SocialLink[]>(`${environment.apiUrl}project/${id}/social`);
  }

  fetch(url: string): Observable<SocialLink> {
    return this.http.get<SocialLink>(`${environment.apiUrl}social/preview?url=${url}`);
  }

  add(url: string, projectId: number): Observable<SocialLink> {
    return this.http.post<SocialLink>(`${environment.apiUrl}project/${projectId}/social?url=${url}`, null, { withCredentials: true });
  }

  delete(projectId: number, id: number): Observable<SocialLink[]> {
    return this.http.delete<SocialLink[]>(`${environment.apiUrl}project/${projectId}/social/${id}`, { withCredentials: true });
  }
}
